const BASE_PATH = '/aqi'

export default {
  getAQIData: query => ({
    url: `${BASE_PATH}/data`,
    method: 'POST',
    data: query
  }),
  getChainAnalysis: query => ({
    url: `${BASE_PATH}/mom`,
    method: 'POST',
    data: query
  }),
  getYOYAnalysis: query => ({
    url: `${BASE_PATH}/yoy`,
    method: 'POST',
    data: query
  }),
  getComposite: query => ({
    url: `${BASE_PATH}/composite/index`,
    method: 'POST',
    data: query
  }),
  getConcentration: query => ({
    url: `${BASE_PATH}/concentration`,
    method: 'POST',
    data: query
  }),
  getMonthly: query => ({
    url: `${BASE_PATH}/monthly/statistics`,
    method: 'POST',
    data: query
  }),
  getContrast: data => ({
    url: `${BASE_PATH}/contrast`,
    method: 'POST',
    data: data
  }),
  createCaseLibrary: data => ({
    url: `${BASE_PATH}/case-library/create`,
    method: 'POST',
    data: data
  }),
  saveCase: data => ({
    url: `${BASE_PATH}/case-library`,
    method: 'POST',
    data: data
  }),
  getCaseLibrary: data => ({
    url: `${BASE_PATH}/case-library/getList`,
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Aqi.js